const mainContent = document.querySelector("#MainContent");
let productColors, variantsLabel;

window.clickEventColor = (dom) => {
  if (!dom) return;
  const elements = dom.forEach ? dom : [dom];
  elements.forEach((color, idx) => {
    if (!color.hasClickEventListener) {
      color.addEventListener("click", async function (e) {
        e.preventDefault();
        const loader = color.querySelector(".loader");
        variantsLabel = document.querySelectorAll("variant-radios");
        const productUrl = this.getAttribute("data-product-url");
        if (loader) loader.classList.remove("hidden");
        if (variantsLabel)
          variantsLabel.forEach((element) =>
            element.setAttribute("disabled", "")
          );
        await window.updateProductContent(productUrl);
        //----------------------------------
      });
      color.hasClickEventListener = true;
    }
  });
};

window.updateProductContent = async (url) => {
  console.log("init script update");
  try {
    const response = await fetch(url);
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    // Actualiza el contenido principal del producto
    const newMainContent = doc.querySelector("#MainContent");

    if (mainContent && newMainContent) {
      mainContent.innerHTML = newMainContent.innerHTML;
      productColors = newMainContent.querySelectorAll(".product__color");
      updateActiveColor(url);
    }
  } catch (error) {
    console.error("Error al actualizar el producto:", error);
  } finally {
    reinitializeScripts();
  }
};

function reinitializeScripts() {
  // Carga dinámica de scripts
  setTimeout(() => {
    // console.log(productColors);
    // loadProductSliderModule();
    window.initProductSlider();
    window.addToCartLogic();
    window.addToCartButton();
    productColors.forEach((color) => {
      window.clickEventColor(color);
    });
  }, 300);
}

let activeColors = document.querySelectorAll(".product__color");
function updateActiveColor(activeUrl) {
  activeColors.forEach((color) => {
    if (color.getAttribute("data-product-url") === activeUrl) {
      color.classList.add("is-active");
    } else {
      color.classList.remove("is-active");
    }
  });

  // ajustando disponibilidad de tallas
  if (typeof adjustVariantAvailabilityOnProductCards === "function") {
    adjustVariantAvailabilityOnProductCards("variant-radios");
  }
}

clickEventColor();
